// export const BASE_API_URL = "http://192.168.1.26:9090";
// export const BASE_API_URL = "http://122.166.195.74";
export const BASE_API_URL = "https://smartind.co.in/api";
// export const BASE_API_URL = "https://smartind.co.in/rpa/api";

